export default "__VITE_ASSET__W_9YAP8L__"